/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Val_On_HoldInputs */

const en_val_on_hold = /** @type {(inputs: Val_On_HoldInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`On Hold`)
};

const id_val_on_hold = /** @type {(inputs: Val_On_HoldInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ditahan`)
};

/** @type {(inputs: Val_On_HoldInputs) => LocalizedString} */
const es_val_on_hold = en_val_on_hold;

/** @type {(inputs: Val_On_HoldInputs) => LocalizedString} */
const fr_val_on_hold = en_val_on_hold;

/** @type {(inputs: Val_On_HoldInputs) => LocalizedString} */
const de_val_on_hold = en_val_on_hold;

/** @type {(inputs: Val_On_HoldInputs) => LocalizedString} */
const ja_val_on_hold = en_val_on_hold;

/** @type {(inputs: Val_On_HoldInputs) => LocalizedString} */
const zh_val_on_hold = en_val_on_hold;

/** @type {(inputs: Val_On_HoldInputs) => LocalizedString} */
const ar_val_on_hold = en_val_on_hold;

/** @type {(inputs: Val_On_HoldInputs) => LocalizedString} */
const it_val_on_hold = en_val_on_hold;

/** @type {(inputs: Val_On_HoldInputs) => LocalizedString} */
const ru_val_on_hold = en_val_on_hold;

/** @type {(inputs: Val_On_HoldInputs) => LocalizedString} */
const pt_val_on_hold = en_val_on_hold;

/** @type {(inputs: Val_On_HoldInputs) => LocalizedString} */
const ko_val_on_hold = en_val_on_hold;

/**
* | output |
* | --- |
* | "On Hold" |
*
* @param {Val_On_HoldInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const val_on_hold = /** @type {((inputs?: Val_On_HoldInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Val_On_HoldInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_val_on_hold(inputs)
	if (locale === "es") return es_val_on_hold(inputs)
	if (locale === "fr") return fr_val_on_hold(inputs)
	if (locale === "de") return de_val_on_hold(inputs)
	if (locale === "ja") return ja_val_on_hold(inputs)
	if (locale === "zh") return zh_val_on_hold(inputs)
	if (locale === "ar") return ar_val_on_hold(inputs)
	if (locale === "id") return id_val_on_hold(inputs)
	if (locale === "it") return it_val_on_hold(inputs)
	if (locale === "ru") return ru_val_on_hold(inputs)
	if (locale === "pt") return pt_val_on_hold(inputs)
	return ko_val_on_hold(inputs)
});